import { render, staticRenderFns } from "./CovidTestCard.vue?vue&type=template&id=4fca5fc6&"
import script from "./CovidTestCard.vue?vue&type=script&lang=js&"
export * from "./CovidTestCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports